/**
 * 排序类型
 */
export enum EOrderType {
  None = 0,
  /**
   * 单选
   */
  Radio = 1,
  /**
   * 多选
   */
  Checkbox = 2,
  /**
   * 排序
   */
  Sort = 3,
  /**
   * 下拉选择
   */
  Select = 4,
  /**
   * 自定义
   */
  PublishPrice = 5,
  /**
   *  商品模式
   */
  Mode = 6,
  /**
   *  意向金支付
   */
  Pay = 7
}



// WEBPACK FOOTER //
// ./src/enums/EOrderType.ts